/**
 * Abonnement QRNYAMA du restaurant, vu par les écrans.
 *
 * Le serveur est seul juge (voir app/logique/abonnements.py) :
 * - réponse 402 « abonnement_expire » : espace bloqué. Le propriétaire est
 *   envoyé vers la page des tarifs pour se réabonner ; un membre de l'équipe
 *   est prévenu qu'il doit contacter son gérant. Côté client (commande par
 *   QR code), c'est l'écran de commande qui affiche le message.
 * - en-tête « X-Abonnement: grace;<date> » : abonnement expiré mais encore
 *   dans les 7 jours de grâce, un avertissement s'affiche une fois par session.
 */
import axios from "axios";
import Swal from "sweetalert2";

let alerteEnCours = false;

const avertirGrace = (dateLimite) => {
  try {
    if (sessionStorage.getItem("abonnement_grace_vu")) return;
    sessionStorage.setItem("abonnement_grace_vu", "1");
  } catch {
    // stockage indisponible : on avertit quand même
  }
  Swal.fire({
    icon: "warning",
    text: `L'abonnement QRNYAMA de ce restaurant a expiré. Il doit être renouvelé avant le ${new Date(dateLimite).toLocaleDateString("fr-FR")}, sinon l'espace et les commandes en ligne seront suspendus.`,
    confirmButtonColor: "#FF6B2C",
  });
};

axios.interceptors.response.use(
  (response) => {
    const entete = response.headers?.["x-abonnement"];
    if (entete && entete.startsWith("grace;")) {
      avertirGrace(entete.split(";")[1]);
    }
    return response;
  },
  (error) => {
    const data = error.response?.data;
    if (error.response?.status === 402 && data?.code === "abonnement_expire" && data.qui !== "client" && !alerteEnCours
        && !window.location.pathname.startsWith("/pricing")) {
      alerteEnCours = true;
      const proprietaire = data.qui === "proprietaire";
      Swal.fire({
        icon: "warning",
        text: data.error,
        confirmButtonText: proprietaire ? "Renouveler mon abonnement" : "OK",
        confirmButtonColor: "#FF6B2C",
        allowOutsideClick: false,
      }).then(() => {
        alerteEnCours = false;
        if (proprietaire) {
          window.location.href = "/pricing";
        }
      });
    }
    return Promise.reject(error);
  }
);
